import { create } from "@/lib/create-safe-store";

export interface ActiveCall {
  callId: string;
  conversationId: string;
  type: "audio" | "video";
  token: string;
  status: "connecting" | "active" | "ended";
  callerName: string;
  isHost?: boolean;
}

export interface IncomingCall {
  callId: string;
  conversationId: string;
  type: "audio" | "video";
  callerId: string;
  callerName: string;
}

interface CallState {
  activeCall: ActiveCall | null;
  incomingCall: IncomingCall | null;
  minimized: boolean;
  setActiveCall: (call: ActiveCall | null) => void;
  setIncomingCall: (call: IncomingCall | null) => void;
  setMinimized: (minimized: boolean) => void;
  setStatus: (status: ActiveCall["status"]) => void;
  clearCall: () => void;
}

export const useCallStore = create<CallState>((set) => ({
  activeCall: null,
  incomingCall: null,
  minimized: false,

  setActiveCall: (call) => set({ activeCall: call }),
  setIncomingCall: (call) => set({ incomingCall: call }),
  setMinimized: (minimized) => set({ minimized }),
  setStatus: (status) =>
    set((state) =>
      state.activeCall ? { activeCall: { ...state.activeCall, status } } : {},
    ),
  clearCall: () => set({ activeCall: null, incomingCall: null, minimized: false }),
}));
